import { __ } from '@wordpress/i18n';

import {
  validate,
  getErrorMessage,
  setErrorMessages,
  rules as validationRules,
  Rules,
  RulesDict,
} from '@Utils/plarium/portal-validator/lib';

const defaultLocalization = {
  required: __('This field is required.', 'plarium-mini-apps'),
  email: __('Please enter a valid email address.', 'plarium-mini-apps'),
  password: __('Password must be between 6-40 alphanumeric characters', 'plarium-mini-apps'),
  terms: __('Please agree on the rules', 'plarium-mini-apps'),
  username: __('Use 3-30 alphanumeric characters.', 'plarium-mini-apps'),
  website: __('Please enter a valid website URL', 'plarium-mini-apps'),
  countryCode: __('Invalid country code. You may use a maximum of 3 numbers', 'plarium-mini-apps'),
  isEqual: __('Field do not match', 'plarium-mini-apps'),
  contactNumber: `Invalid phone number. You may use up to 17 characters.
  Including numbers 0-9 and characters +. () and -`,
  code: __('Invalid code. Must be 6 numbers', 'plarium-mini-apps'),
  playerId: __(
    'Check the Player ID for typos or missing characters and try again',
    'plarium-mini-apps',
  ),
};

const userRaidIdRegExp = new RegExp(/^(um[0-9]*\s?[|]\s?[0-9]*)$/);

setErrorMessages(defaultLocalization);

type CommonFields = Partial<typeof defaultLocalization>;

export type FieldsValidationRules = Rules;

export function getValidator<T extends CommonFields>(
  userValidationRules: Rules<keyof T, any>,
  localizedErrors: T,
) {
  setErrorMessages(localizedErrors);
  return function validateFields(values: Partial<T>): Promise<any> {
    return validate(values, userValidationRules);
  };
}

const allRules: RulesDict = {
  ...validationRules,
  terms: (value) => {
    if (!value) {
      return Promise.reject(getErrorMessage('terms'));
    }

    return Promise.resolve();
  },
  countryCode: (value) => {
    if (!(value && value.length && value.length <= 3)) {
      return Promise.reject(getErrorMessage('countryCode'));
    }

    return Promise.resolve();
  },
  about: (value) => {
    if (value.length > 360) {
      return Promise.reject(getErrorMessage('about'));
    }

    return Promise.resolve();
  },
  code: (value) => {
    if (value && value.length && value.length !== 6) {
      return Promise.reject(getErrorMessage('code'));
    }

    return Promise.resolve();
  },
  playerId: (value) => {
    if (hasPlayerId(value)) {
      return Promise.resolve();
    }

    return Promise.reject(getErrorMessage('playerId'));
  },
};

function hasPlayerId(value: string) {
  return userRaidIdRegExp.test(value);
}

export const isEqual = (value: unknown, match: unknown) => {
  if (value !== match) {
    return Promise.reject(getErrorMessage('isEqual'));
  }

  return Promise.resolve();
};

export { allRules as rules, setErrorMessages };
